import React,{useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { clientAppUserLogin } from "../../../store/actions/User";

import Loading from "../../Loading/Loading";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUpT1.css'
import {  Link  } from "react-router-dom";
const LoginT1 = ()=>{
  const [isHovered, setIsHovered] = useState(false);

  const dispatch = useDispatch();
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });

    const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
  

    useEffect(()=>{
      dispatch({
        type: "pageTitle",
        
        payload:"Login | MyApp"
      });
      dispatch({
        type: "pageDescription",
        
        payload:"This is a dynamic description."
      });dispatch({
        type: "pageSEO",
        
        payload:"seo, react, meta"
      });
    },[])
   


  
//  const data = useSelector((state)=>state?.user?.user);
// console.log(data )
 const history = useHistory();
 
 const localToken= localStorage.getItem("profile");
 const token = useSelector((state)=>state?.user?.user?.token);


 const [loader , setLoader] =useState({status:false});
 const [login, setLogin] = useState({userEmail:'',userPassword:""
 
});

 
   const [loginPopUp , setLoginPopUp] =useState(true);


/* Handle Signup Function */
const handleLogin=(e)=>{

  e.preventDefault();
//console.log(signup)

setLoader({status:true});
  const user = dispatch(clientAppUserLogin(login));
  /* get response as Promise   */
  user.then(response => {
  // pop up with message 
   console.log(response)
   
   setInterval(()=>{
    // hide poped message 
    
   },3000)
   
/* resetting Login input Fields */

setLogin({userEmail:'',userPassword:""

})

setLoader({status:false});


// history.push('/dashboard');


  }).catch(error => {
    
/* resetting Login input Fields */
//setLogin({user_email:'',user_pass:""

// })
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
     
{(token===localToken&&token&&localToken)?
<>
<div className="outer-all ">
  
<div></div>
  <div className = {` outer-left `}  id="outer-left">
  
 
      
      </div>
    <div className="outer-right">
        <div className="content-topk">
          <h1> You Are Already logged In</h1>
          
        </div>
        <div className="outer-logged-in">

{/* <div class="cm-outer-mask"><div class="cm-outer"><ul class="cm-inn">
<li>

<img class="img-cm-inn" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
</ul></div></div> */}
{/* <div class="cm-outer-mask-2"><div class="cm-outer-2"><ul class="cm-inn-2">
<li>

<img class="img-cm-inn-2" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn-2" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn-2" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
</ul></div></div>

<div class="cm-outer-circle-mask"><div class="cm-outer-circle"><ul class="cm-inn-circle">
<li>

<img class="img-cm-inn-circle" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn-circle" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn-circle" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
</ul></div></div> */}

{/* <div class="cm-outer-circle-mask-2"><div class="cm-outer-circle-2"><ul class="cm-inn-circle-2">
<li>

<img class="img-cm-inn-circle-2" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn-circle-2" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
<li>

<img class="img-cm-inn-circle-2" data-src="//c.superprof.com/img/mat/144/17/baile.jpg" src="//c.superprof.com/img/mat/144/17/baile.jpg"/>
</li>
</ul></div></div> */}

</div></div></div>
</> :<>

     
{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleLogin} >
  {loginSignUpPopUp=="login"?<div onClick={() => dispatch({
    type: "LoginSignUpPopUp",
    
    payload:""
  })}  className="cm_theme1_login-signup-backgropj"></div>:""} 
    
    <div  className="cm_theme1_login-signup-card"><div  className="blank"> </div>
  <div  className="cm_theme1_login-signup-card-outerj"><div  className="cm_theme1_login-signup-inner">
  <div  className="cm_theme1_blankRight cm_theme1_login-signup-right-signup">
  
    <div>   <div  className="flex-space-between">  <div  style={{width:"240px",padding:"15px",borderRadius:"15px",marginTop:"50px"}}><img style={{width:"100%"}}
       alt="logo" src="https://i.postimg.cc/7Zwy3WW9/Testprism_Logo.png"/> </div>

      </div>
      
<h3  style={{textAlign:"center"}}>App Tag Line</h3>
<div className="logo-box-shadow">
<div className=""  style={{padding:'10px',color:"#222",fontSize:'22px',textAlign:"center"}}> New To App Name?  </div>
<div  className=""  style={{padding:'10px',color:"#666",fontSize:'15px',textAlign:"center"}}>
  Sign up as a student to enjoy the benefits of App Name  . </div>

       <div className="flex-space-between">
    {loginPopUp?<div  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
    onClick={() => dispatch({
      type: "LoginSignUpPopUp",
      
      payload:"signUp"
    })} className="cm_theme1_course-btn-green-two" style={{fontSize:"16px"}}>
     Sign Up Here
    </div>:<Link to="./signup">
      <div  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="cm_theme1_course-btn-green-two" style={{fontSize:"16px"}}>
     Sign Up Here
    </div> </Link>}</div></div></div>
    </div>  <div  className="cm_theme1_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Login </h1>
      
 <div  className="cm_theme1_login-input-card">
 <input  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="cm_theme1_input-textbox" required placeholder="Email" type="text"
  name="user_email" value={login.userEmail} onChange={(e)=>setLogin({...login, userEmail : e.target.value})} />
   </div><div  className="cm_theme1_login-input-card">
    
     <input  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="cm_theme1_input-textbox" required placeholder="Password" 
     type="text" name="user_pass" value={login.userPassword}
      onChange={(e)=>setLogin({...login, userPassword : e.target.value})} />
    </div>
	  
   
   
    
   
     
   
	
	<div  className="cm_theme1_login-input-card">
   
  <button  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="cm_theme1_login-signup-button" type="submit" id="signupBtn">Click To Login</button>
      
  </div>
  <div className="cm_theme1_Signup-bottom" style={{margin:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  style={{padding:'15px',fontSize:'15px',}} > Forgot Password?  </div>
    {loginSignUpPopUp=="login"? <span
     onClick={() => dispatch({
      type: "LoginSignUpPopUp",
      
      payload:"resetPassword"
    })}  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{padding:'15px',cursor:"pointer",fontSize:'12px', fontWeight:'bold',marginBottom:'10px',color:'#996699'}}> 
    Click To Reset. </span> :
  <Link to="./resetPassword">
    <span  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} style={{padding:'15px',cursor:"pointer",fontSize:'12px', fontWeight:'bold',marginBottom:'10px',color:'#996699'}}> 
      Click To Reset. </span> </Link>}</div>
  
<div style={{padding:'5px',fontSize:'18px',color:'#958FDA',textAlign:'center'}} > OR </div>
{loginSignUpPopUp=="login"?<div  className="cm_theme1_login-input-card">
   
   <button onClick={() => dispatch({
       type: "LoginSignUpPopUp",
       
       payload:"loginWithOTP"
     })}  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}   className="cm_theme1_login-signup-button-two" type="submit" id="signupBtn">Login With OTP </button>
       
   </div>:<Link to="./loginWithOTP">
  <div  className="cm_theme1_login-input-card">
   
  <button   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   className="cm_theme1_login-signup-button-two" type="submit" id="signupBtn">Login With OTP </button>
      
  </div></Link>}
  <div> 
    
    
    
    
  </div>
 </div>
    
    
  </div></div><div></div></div>
   </form>
</>}
    </>

}
export default LoginT1;